module.exports = __webpack_public_path__ + "img/medal.02765c31.svg";